import React from 'react';
import { intlShape, injectIntl } from 'react-intl';
import { Bar } from 'react-chartjs-2';
import randomstring from 'uuid/v4';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';

import ModifyRange from './ModifyRange';
import { Round } from '../../../../functions/Maths';

function getDataSet(initial, current, props) {
    return {
        labels: initial.map((d) => {
            return d.hora;
        }),
        datasets: [
            {
                label: props.intl.formatMessage({ id: 'modification_forecast_current' }),
                data: initial.map((d) => {
                    return d.importe;
                }),
                backgroundColor: 'rgba(85, 94, 212, 1)',
            },
            {
                label: props.intl.formatMessage({ id: 'modification_forecast_new' }),
                data: current.map((d) => {
                    return d.importe;
                }),
                backgroundColor: 'rgba(163, 171, 222, 1)',
            },
        ],
    };
}

class Forecast extends React.Component {
    state = {
        initial:
            this.props && this.props.info && this.props.info.initial ? this.props.info.initial : [],
        current:
            this.props && this.props.info && this.props.info.current ? this.props.info.current : [],
        data: getDataSet(
            this.props && this.props.info && this.props.info.initial ? this.props.info.initial : [],
            this.props && this.props.info && this.props.info.current ? this.props.info.current : [],
            this.props,
        ),
        leyend: undefined,
        disabled: false,
        hours:
            this.props && this.props.info && this.props.info.initial
                ? this.props.info.initial.map((d, index) => {
                      return { name: d.hora, id: index };
                  })
                : [],
        currentId: randomstring(),
        importes:
            this.props && this.props.info && this.props.info.importes
                ? this.props.info.importes
                : [],
        importesbase:
            this.props && this.props.info && this.props.info.importesbase
                ? this.props.info.importesbase
                : [],
    };

    static getDerivedStateFromProps(props, state) {
        if (
            props.forecast &&
            (props.ventadia !== state.ventadia ||
                props.id !== state.id ||
                props.index !== state.index)
        ) {
            state.disabled = props.disabled;
            state.ventadia = props.info ? props.ventadia : 0;
            state.id = props.id;
            state.leyend = props.leyend;
            state.index = props.index;
            state.desvioactualuds =
                props && props.info && props.info.desvioactualuds ? props.info.desvioactualuds : '';
            state.initial = props && props.info && props.info.initial ? props.info.initial : [];
            state.current = props && props.info && props.info.current ? props.info.current : [];
            state.importes = props && props.info && props.info.importes ? props.info.importes : [];
            state.importesbase =
                props && props.info && props.info.importesbase ? props.info.importesbase : [];
            state.data = getDataSet(state.initial, state.current, props);
            state.importemix =
                props && props.info && props.info.importemix ? props.info.importemix : [];
            state.currentId = randomstring();
            state.hours =
                props && props.info && props.info.initial
                    ? props.info.initial.map((d, index) => {
                          return { name: d.hora, id: index };
                      })
                    : [];
            return state;
        }
        return null;
    }

    handleUpdate = (percentage, hour, ranges) => {
        const { current, initial, index } = this.state;
        current.map((c, position) => {
            if (
                position >= parseInt(hour, 10) &&
                !c.bloqueado &&
                position < parseInt(hour, 10) + parseInt(ranges, 10)
            ) {
                c.importe =
                    Math.round((c.importe + (c.importe * parseInt(percentage, 10)) / 100) * 100) /
                    100;
                return c;
            } else {
                return c;
            }
        });
        this.props.onChange(index, current);
        this.setState({
            current: current,
            currentId: randomstring(),
            data: getDataSet(initial, current, this.props),
        });
    };

    handleChange = (id, value) => {
        const { current, initial, index } = this.state;
        current[id].importe = parseInt(value, 10);
        this.props.onChange(index, current);
        this.setState({ current: current, data: getDataSet(initial, current, this.props) });
    };

    render() {
        const { intl } = this.props;
        const {
            initial,
            current,
            data,
            leyend,
            disabled,
            hours,
            currentId,
            importes,
            importesbase,
            importemix,
            desvioactualuds,
        } = this.state;
        let index = 0;
        const total_current_units = current.reduce((total, i) => {
            total += Math.round((importes[index].importe * i.importe) / importemix);
            index = index + 1;
            return total;
        }, 0);
        index = 0;
        const total_initial_units = initial.reduce((total, i) => {
            total += Math.round((importesbase[index].importe * i.importe) / importemix);
            index = index + 1;
            return total;
        }, 0);

        return (
            <React.Fragment>
                <Card className={'production_forecast_card '}>
                    <CardContent>
                        <Grid container className={'flex_grow_1'}>
                            <Grid item xs={12} className="">
                                <div className="barlow_medium c_dark_grey_blue text_align_left">
                                    {intl.formatMessage({ id: 'production_productmix_card' })}
                                </div>
                            </Grid>
                            <Grid item xs={12} className="">
                                <article className="canvas-container">
                                    <Bar
                                        height={200}
                                        width={100}
                                        data={data}
                                        options={{
                                            maintainAspectRatio: false,
                                            legend: {
                                                display: true,
                                                position: 'bottom',
                                            },
                                            scales: {
                                                yAxes: [
                                                    {
                                                        scaleLabel: {
                                                            display: true,
                                                            labelString: leyend,
                                                        },
                                                        ticks: {
                                                            beginAtZero: true,
                                                            min: 0,
                                                        },
                                                    },
                                                ],
                                            },
                                        }}
                                    />
                                </article>
                            </Grid>
                            {!disabled && (
                                <Grid item xs={12} className="padding_top_24">
                                    <ModifyRange hours={hours} onUpdate={this.handleUpdate} />
                                </Grid>
                            )}
                            <Grid item xs={12} className="padding_top_24">
                                <Grid container className={'flex_grow_1'}>
                                    {current &&
                                        current.map((c, index) => {
                                            const before = initial[index];
                                            return (
                                                <Grid
                                                    key={`current-${index}-${currentId}`}
                                                    item
                                                    xs={2}
                                                    className="margin_bottom_24"
                                                >
                                                    <div className="flex_full_row padding_right_36">
                                                        {c.pasado &&
                                                            <div className="flex_full_row c_bluish barlow_regular_small margin_bottom_5">
                                                                {c.hora}
                                                            </div>
                                                        }
                                                        {!c.pasado &&
                                                            <div className="flex_full_row c_cool_grey barlow_regular_small margin_bottom_5">
                                                                {c.hora}
                                                            </div>
                                                        }
                                                        {before &&
                                                            c &&
                                                            before.importe !== c.importe && (
                                                                <span className="flex_auto_row text_align_end barlow_regular_small c_purple nowrap">
                                                                    {Round(before.importe)}
                                                                </span>
                                                            )}
                                                    </div>
                                                    <div className="flex_full_row padding_right_36">
                                                        {c.bloqueado || disabled ? (
                                                            <span className="flex_full_row text_align_end barlow_regular c_dark_grey_blue">
                                                                {Round(c.importe)}
                                                            </span>
                                                        ) : (
                                                            <TextField
                                                                fullWidth
                                                                id={`forecast-${index}`}
                                                                name={`forecast-${index}`}
                                                                required
                                                                className={'flex_full_row'}
                                                                classes={{
                                                                    root:
                                                                        'production_total_card_input',
                                                                }}
                                                                defaultValue={c.importe}
                                                                onChange={(event) =>
                                                                    this.handleChange(
                                                                        index,
                                                                        event.target.value,
                                                                    )
                                                                }
                                                                margin="normal"
                                                                InputProps={{
                                                                    pattern: '[0-9]*',
                                                                    classes: {
                                                                        input:
                                                                            'c_dark_grey_blue barlow_regular text_align_right',
                                                                    },
                                                                }}
                                                            />
                                                        )}
                                                    </div>
                                                </Grid>
                                            );
                                        })}
                                    <Grid item xs={12} className="margin_bottom_24">
                                        <span className="barlow_italic c_dark_grey_blue">
                                            {leyend}
                                        </span>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                <Card className={'production_forecast_card'}>
                    <CardContent>
                        <Grid container className={'flex_grow_1'}>
                            <Grid item xs={12} className="margin_bottom_24">
                                <div className="barlow_medium c_dark_grey_blue text_align_left">
                                    {intl.formatMessage({
                                        id: 'production_productmix_card_resume',
                                    })}
                                </div>
                            </Grid>
                            <Grid item xs={3} className="center margin_bottom_24 flex_full_column">
                                <div className="flex_auto_row barlow_regular_title c_dark_grey_blue text_align_left">
                                    {intl.formatMessage({
                                        id: 'production_productmix_card_forecast',
                                    })}
                                </div>
                                <div className="flex_auto_row barlow_regular_title c_dark_grey_blue text_align_left margin_top_8">
                                    {Round(total_initial_units)}
                                </div>
                            </Grid>
                            <Grid item xs={3} className="center margin_bottom_24 flex_full_column">
                                <div className="barlow_regular_title c_dark_grey_blue text_align_left">
                                    {intl.formatMessage({
                                        id: 'production_productmix_card_input',
                                    })}
                                </div>
                                <div className="flex_auto_row barlow_regular_title c_dark_grey_blue text_align_left margin_top_8">
                                    {Round(total_current_units)}
                                </div>
                            </Grid>
                            <Grid item xs={3} className="center margin_bottom_24 flex_full_column">
                                <div className="barlow_regular_title c_dark_grey_blue text_align_left">
                                    {intl.formatMessage({
                                        id: 'production_productmix_card_percentage_actual',
                                    })}
                                </div>
                                <div className="barlow_semibold_label c_cornflower_blue text_align_left margin_top_8">
                                    {Round(desvioactualuds) + '%'}
                                </div>
                            </Grid>
                            <Grid item xs={3} className="center margin_bottom_24 flex_full_column">
                                <div className="barlow_regular_title c_dark_grey_blue text_align_left">
                                    {intl.formatMessage({
                                        id: 'production_productmix_card_percentage_final',
                                    })}
                                </div>
                                <div className="barlow_semibold_label c_cornflower_blue text_align_left margin_top_8">
                                    {Round(
                                        (total_current_units * 100) / total_initial_units - 100,
                                    ) + '%'}
                                </div>
                            </Grid>
                            {current &&
                                current.map((c, index) => {
                                    const before = Math.round(
                                        (importesbase[index].importe * initial[index].importe) /
                                            importemix,
                                    );
                                    const actual_celd = Math.round(
                                        (importes[index].importe * c.importe) / importemix,
                                    );
                                    return (
                                        <Grid
                                            key={`current-${index}-${currentId}`}
                                            item
                                            xs={2}
                                            className="margin_bottom_24"
                                        >
                                            <div className="flex_full_row padding_right_36">
                                                {c.pasado &&
                                                    <div className="flex_full_row c_bluish barlow_regular_small margin_bottom_5">
                                                        {c.hora}
                                                    </div>
                                                }
                                                {!c.pasado &&
                                                    <div className="flex_full_row c_cool_grey barlow_regular_small margin_bottom_5">
                                                        {c.hora}
                                                    </div>
                                                }
                                                {before !== actual_celd && (
                                                    <span className="flex_auto_row text_align_end barlow_regular_small c_purple nowrap">
                                                        {before}
                                                    </span>
                                                )}
                                            </div>
                                            <div className="flex_full_row padding_right_36">
                                                <span className="flex_full_row text_align_end barlow_regular c_dark_grey_blue">
                                                    {actual_celd}
                                                </span>
                                            </div>
                                        </Grid>
                                    );
                                })}
                        </Grid>
                    </CardContent>
                </Card>
            </React.Fragment>
        );
    }
}

Forecast.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(Forecast);



// WEBPACK FOOTER //
// ./src/components/complex/inventory/forecast/ProductMix.js